import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = '/api/data/';
//const  API_URL = 'http://localhost:8080/api/data/';
const API_URL = process.env.REACT_APP_API_URL + 'api/data/';

class DataService {

    getModules(id) {
        return axios.get(API_URL + 'modules?ID=' + id, { headers: authHeader() });
    }

    getClusters(id) {
        return axios.get(API_URL + 'clusters?ID=' + id, { headers: authHeader() });
    }

    getSystems(id) {
        return axios.get(API_URL + 'systems?ID=' + id, { headers: authHeader() });
    }

    getBasicSystems(id) {
        return axios.get(API_URL + 'basicSystems?ID=' + id, { headers: authHeader() });
    }

    getLogg(id) {
        return axios.get(API_URL + 'logg?ID=' + id, { headers: authHeader() });
    }

    getGNSS(id,IMEI,days) {
        return axios.get(API_URL + 'GNSSdata?ID=' + id + '&IMEI=' + IMEI + '&DAYS=' + days, { headers: authHeader() });
    }

    getSensor(id,IMEI,lamp,days) {
        return axios.get(API_URL + 'SensorData?ID=' + id + '&IMEI=' + IMEI + '&lamp=' + lamp + '&DAYS=' + days, { headers: authHeader() });
    }

    getSensorPeriod(id,IMEI,lamp,fromDate,toDate) {
        return axios.get(API_URL + 'SensorData?ID=' + id + '&IMEI=' + IMEI + '&lamp=' + lamp + '&fromDate=' + fromDate + '&toDate=' + toDate, { headers: authHeader() });
    }

    updateLogg({ id, systemId, active, comment, overrideStatus }) {
        return axios.post(
            API_URL + 'updateLogg',
            {
                id,
                systemId,
                active,
                comment,
                overrideStatus,
            },
            { headers: authHeader() }
        );
    }

    MQTTPub(IMEI,pubMsg) {
        return axios.get(API_URL + 'MQTTPub?IMEI=' + IMEI + '&pubMsg=' + pubMsg, { headers: authHeader() });
    }

}

//export default new DataService();
const dataService = new DataService();
export default dataService;